import { Col, Row } from 'antd';
import { NumericFormat } from 'react-number-format';
import { convertDateESTToUTCToUserLocal, formateWithMoment } from '../../../../../utilz/dates';
import Checkbox from '../../../../components/Inputs/Checkbox';
import BatchLabel from '../../../../components/Labels/BatchLabel';
import PrimaryLabel from '../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../components/Paper/Paper';
import TMSFiledCard from '../../../common/components/TMSFiledCard';

const LossAndDamageListCard = ({ data, onSelect, isSelected, handleClaimClick }) => {
  const createdOnLabel = data.createdOn ? formateWithMoment(convertDateESTToUTCToUserLocal(data.createdOn)) : 'NA';

  const dateFiledLabel = data.dateFiled ? formateWithMoment(convertDateESTToUTCToUserLocal(data.dateFiled)) : 'NA';

  const handleCheckBoxClick = (e) => {
    e.stopPropagation();
    onSelect(data.claimKey, isSelected);
  };

  return (
    <Paper className={`shipment-card border-muted ${isSelected ? 'selected' : ''}`}>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div className="p-15 " onClick={() => handleClaimClick(data.claimKey)}>
        <Row gutter={15}>
          <Col>
            <Checkbox onClick={handleCheckBoxClick} checked={isSelected} />
          </Col>
          <Col className="flex-1">
            <Row gutter={15}>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Claim Number">
                  <PrimaryLabel>{data.claimNumber}</PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Freight Bill / Pro Number">
                  {data.claimProNo}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Invoice Number">
                  {data.invoiceNo}
                </TMSFiledCard>
                <TMSFiledCard title="Transportation Provider">{data.carrierName}</TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Consignee">
                  {data.consignee}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-8" title="Amount Filed">
                  <PrimaryLabel className="text-iconDanger">
                    <NumericFormat
                      thousandsGroupStyle="lakh"
                      displayType="text"
                      value={String(data.claimTotal)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-8" title="Amount Paid">
                  <PrimaryLabel className="text-success">
                    <NumericFormat
                      thousandsGroupStyle="lakh"
                      displayType="text"
                      value={String(data.claimPaidAmount)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
                <TMSFiledCard title="Difference Amount">
                  <PrimaryLabel className="text-header">
                    <NumericFormat
                      thousandsGroupStyle="lakh"
                      displayType="text"
                      value={String(data.difference)}
                      thousandSeparator
                    />
                  </PrimaryLabel>
                </TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Claim Type">
                  {data.claimType}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Claim Status">
                  <BatchLabel>{data.claimStatus}</BatchLabel>
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Filed Date">
                  {dateFiledLabel}
                </TMSFiledCard>
                <TMSFiledCard title="Closed Date">
                  {data.claimCloseDate ? formateWithMoment(data.claimCloseDate) : 'NA'}
                </TMSFiledCard>
              </Col>
              <Col sm={6}>
                <TMSFiledCard containerClass="mb-10" title="Created On">
                  {createdOnLabel}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Created By">
                  {data.createdByUser}
                </TMSFiledCard>
                <TMSFiledCard containerClass="mb-10" title="Modified On">
                  {data.modifiedOn ? formateWithMoment(data.modifiedOn) : 'NA'}
                </TMSFiledCard>
                <TMSFiledCard c title="Modified By">
                  {data.modifiedByUser}
                </TMSFiledCard>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Paper>
  );
};

export default LossAndDamageListCard;
